import StarOutlineIcon from "@mui/icons-material/StarOutline";
import StarRateIcon from "@mui/icons-material/StarRate";
import Checkbox from "@mui/material/Checkbox";

const StarCheckbox = ({
                          isSelected,
                          changeEvent = () => {
                              alert("Please pass function for handling the click event");
                          }
                      }) => (
    <Checkbox
        sx={{
            color: "#000",
            p: 0,
            "&.Mui-checked": {
                color: "#FFD600 !important"
            }
        }}
        className="star-shaped-checkbox"
        icon={<StarOutlineIcon/>}
        checkedIcon={<StarRateIcon/>}
        checked={isSelected || false} // Set the initial checked state
        onChange={changeEvent}
    />
);

export default StarCheckbox;